import React from "react";
import { SportsMatches, SportsTable, SportsTicker } from "../helper/interfaces";
import Image from 'next/image';
import { SportsTickerEventType } from "../helper/enums";
import { MatchState } from "../helper/enums";
import TickerEncounter from "./TickerEncounter";
import TickerTable from "./TickerTable";
import TickerLineup from "./TickerLineup";

export default function Ticker(data: {sportsTicker?: SportsTicker | null, sportsMatches?: SportsMatches | null, sportsTables?: SportsTable[] | null}) {
  const sportsticker = data.sportsTicker ?? null;
  const sportstables= data.sportsTables ?? null;
  const sportsmatches = data.sportsMatches ?? null;
  
  return (
    <React.Fragment>
      <div className="ticker">
        <header>
          <div className="ticker__row ticker__topnav">
            <a href="#ticker">
              <span className="btn_kickNav">Ticker</span>
            </a>
            {sportsticker?.lineup && (
              <a href="#aufstellung">
                <span className="btn_kickNav">Aufstellung</span>
              </a>
            )}
            {sportsmatches?.matches && (
              <a href="#spieltag">
                <span className="btn_kickNav">Spieltag</span>
              </a>
            )}
            {sportstables && sportstables.length > 0 && (
              <a href="#tabelle-0">
                <span className="btn_kickNav">{`Tabelle${sportstables.length > 1 ? "n" : ""}`}</span>
              </a>
            )}
          </div>
          <div className="ticker__header border-top">
            <div className="ticker__header__wrapper">
              <h2 className="modul__teaser__headline">
               {sportsticker?.header?.tournament && (
                  <span className="article-author-name-span">{sportsticker.header.tournament} – </span>
                )}
                <span className="article-author-name-span">Liveticker</span>
              </h2>
            </div>
            <div className="kick__modul__item">
              <div className="kick__v100-scoreboardInfo">
                {sportsticker?.header?.scoreBoardInfo?.saison && (
                  <span>{sportsticker.header.scoreBoardInfo.saison}</span>
                )}
                {sportsticker?.header?.scoreBoardInfo?.matchday && (
                  <span>, {sportsticker.header.scoreBoardInfo.matchday}</span>
                )}
              </div>
              <div className="kick__v100-gameCell kick__v100-gameCell--big">
                <span className="kick__v100-gameCell__team">
                  {sportsticker?.header?.homeTeam?.name && (
                    <div className="kick__v100-gameCell__team__name">{sportsticker?.header?.homeTeam?.name}</div>
                  )}
                  <div className="kick__v100-gameCell__team__logo">
                    {sportsticker?.header?.homeTeam?.icon && <Image src={sportsticker?.header?.homeTeam?.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />}
                  </div>
                </span>
                <div id="scoreBoard" className="kick__v100-scoreBoard kick__v100-scoreBoard--big-wider">
                  {(sportsticker?.header?.score?.score || sportsticker?.header?.matchDate) && (
                    <div>
                      {sportsticker.header.score.score.indexOf(":") > 0 && (
                        <div className={`kick__v100-scoreBoard__scoreHolder ${sportsticker.header.score.state == MatchState.Live ? 'scoreHolder_live' : ''}`}>
                          <div className="kick__v100-scoreBoard__scoreHolder__score">{sportsticker.header.score.score.split(":")[0]}</div>
                          <div className="kick__v100-scoreBoard__scoreHolder__divider">:</div>
                          <div className="kick__v100-scoreBoard__scoreHolder__score">{sportsticker.header.score.score.split(":")[1]}</div>
                        </div>
                      )}
                      {sportsticker.header.matchDate && (
                        <div className="kick__v100-scoreBoard__scoreHolder">
                          <div className="">{sportsticker.header.matchDate}</div>
                        </div>
                      )}
                      {sportsticker.header.score.subline && (sportsticker.header.score.subline != sportsticker.header.score.halfTimeScore) && (
                        <div className="kick__v100-scoreBoard__scoreHolder scoreHolder_subline">
                          <div className="score_subline">{sportsticker.header.score.subline}</div>
                        </div>
                      )}
                    </div>
                  )}
                  <div>
                    {sportsticker?.header?.score?.halfTimeScore && (sportsticker?.header?.score?.subline != sportsticker?.header?.score?.halfTimeScore) && (
                      <div>
                        <div className="kick__v100-scoreBoard__scoreHolder kick__v100-scoreBoard__scoreHolder--subscore">
                          <div className="score_subline">{sportsticker.header.score.halfTimeScore}</div>
                        </div>
                      </div>
                    )}
                    {(sportsticker?.header?.score?.subline == sportsticker?.header?.score?.halfTimeScore) && (
                      <div>
                        <div className="kick__v100-scoreBoard__scoreHolder kick__v100-scoreBoard__scoreHolder--subscore">
                          <div className="score_subline">{sportsticker?.header?.score?.subline}</div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <span className="kick__v100-gameCell__team">
                  {sportsticker?.header?.awayTeam?.name && (
                    <div className="kick__v100-gameCell__team__name">{sportsticker.header.awayTeam.name}</div>
                  )}
                  <div className="kick__v100-gameCell__team__logo">
                    {sportsticker?.header?.awayTeam?.icon && <Image src={sportsticker?.header?.awayTeam?.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />}
                  </div>
                </span>
              </div>
            </div>
            <div className="kick__card">
              <div className="kick__site-padding">
                {sportsticker?.header?.goals && (
                  <div id="goals" className="kick__goals kick__goals--ingame kick__goals--ingame_ticker">
                    {sportsticker.header.goals.map((goal) =>   
                      <div className="kick__goals__row" key={`goal-${goal.minute}-${goal.additionalMinute}-${goal.home}}-${goal.away}-${goal.headline}`}>
                        <div className="kick__goals__team kick__goals__team--left">
                          {goal.home}
                        </div>
                        <div className="kick__goals__time kick__goals__time--left">
                          {goal.home && (
                             <span>
                              {goal.minute}
                              {goal.additionalMinute && goal.additionalMinute > 0 && (
                                <span className="kick__goals__time__extra">+ {goal.additionalMinute}</span>
                              )}
                             </span>
                          )}
                         
                        </div>
                        <div className="kick__goals__score">
                          <div className="kick__v100-scoreBoard kick__v100-scoreBoard--standard kick__v100-scoreBoard--goals__score">
                            <div className="kick__v100-scoreBoard__scoreHolder kick__v100-scoreBoard__scoreHolder--transparent">
                              <div className="kick__v100-scoreBoard__scoreHolder__score">{goal.headline?.split(":")[0]}</div>
                              <div className="kick__v100-scoreBoard__scoreHolder__divider">:</div>
                              <div className="kick__v100-scoreBoard__scoreHolder__score">{goal.headline?.split(":")[1]}</div>
                            </div>
                          </div>
                        </div>
                        <div className="kick__goals__time kick__goals__time--right">
                          {goal.away && (
                              <span>
                                {goal.minute}
                                {goal.additionalMinute && goal.additionalMinute > 0 && (
                                  <span className="kick__goals__time__extra">+ {goal.additionalMinute}</span>
                                )}
                              </span>
                          )}
                        </div>
                        <div className="kick__goals__team kick__goals__team--right">
                          {goal.away}
                        </div>
                      </div>
                    )}
                    </div>
                )}
              </div>
            </div>
          </div>
          <div className="kick__data-grid">
            <div className="kick__data-grid__main">
              <div className="kick__ticker ticker__row kick__card kick__ressort-headline kick__site-padding">
                <div id="ticker" className="kick__ticker kick__ticker--wide">
                  {sportsticker?.events?.map((event) =>
                    <div  key={`event-${event.minute}-${event.additionalMinute}-${event.type}-${event.headline}-${event.text}-${event.subline}`}>
                      { event.type == SportsTickerEventType.Goal &&
                        <div className="kick__ticker__row kick__ticker__row--goal">
                          <div className="kick__ticker__cell-info">
                            <div className="kick__ticker__time-info">
                              <div className="kick__js-show-inline-tooltip kick__inline-tooltip-holder kick__ticker__minute">
                                {event.minute && (
                                  <span>{event.minute}&apos;</span>
                                )}
                                {event.additionalMinute && event.additionalMinute > 0 && (
                                  <span className="kick__goals__time__extra">+ {event.additionalMinute}</span>
                                )}
                              </div>
                            </div>
                            <div className="kick__ticker__meta-info">
                              <span className="kick__ticker-icon kick__ticker-icon-color--black kick__icon-Fussball"></span>
                            </div>
                          </div>
                          <div className="kick__ticker__cell-text">
                            <div className="kick__ticker__cell-text-inner">
                              <strong className="kick__ticker__cell-text--important kick__ticker__cell-text__score-message">{event.headline}<br /></strong>
                              <strong>{event.subline}<br /></strong>
                              <div>{event.text}</div>
                            </div>
                          </div>
                        </div>
                      }
                      { event.type != SportsTickerEventType.Goal &&
                        <div className="kick__ticker__row">
                          <div className="kick__ticker__cell-info">
                            {event.minute && (
                              <div className="kick__ticker__time-info">
                                <div className="kick__js-show-inline-tooltip kick__inline-tooltip-holder kick__ticker__minute">
                                  {event.minute && (
                                    <span>{event.minute}&apos;</span>
                                  )}
                                  {event.additionalMinute && event.additionalMinute > 0 && (
                                    <span className="kick__goals__time__extra">+ {event.additionalMinute}</span>
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="kick__ticker__meta-info">
                              { event.type == SportsTickerEventType.YellowCard &&
                                <span className="kick__ticker-icon kick__ticker-icon-color--yellow kick__icon-Gelb"></span>
                              }
                              { event.type == SportsTickerEventType.RedCard &&
                                <span className="kick__ticker-icon kick__ticker-icon-color--red kick__icon-Gelb"></span>
                              }
                              { event.type == SportsTickerEventType.YellowRedCard &&
                                <span>
                                  <span className="kick__ticker-icon kick__ticker-icon-color--yellow kick__icon-Gelb ticker-yellow-red-first-card"></span>
                                  <span className="kick__ticker-icon kick__ticker-icon-color--red kick__icon-Gelb"></span>
                                </span>
                              }
                              { event.type == SportsTickerEventType.Substitution &&
                                <div className="kick__ticker-icon-array">
                                  <span className="kick__ticker-icon kick__ticker-icon-color--green kick__icon-Pfeil02"></span>
                                  <span className="kick__ticker-icon kick__ticker-icon-color--red kick__icon-Pfeil01"></span>
                                </div>
                              }
                              { event.type == SportsTickerEventType.Penalty &&
                                <span className="kick__ticker-icon kick__ticker-icon-color--black kick__icon-Elfmeter01"></span>
                              }
                              { event.type == SportsTickerEventType.PenaltyMiss &&
                                <span className="kick__ticker-icon kick__ticker-icon-color--black kick__icon-Elfmeter_verschossen"></span>
                              }
                              { event.type == SportsTickerEventType.VideoAssist &&
                                <span className="kick__ticker-icon kick__ticker-icon-color--black kick__icon-Videobeweis"></span>
                              }
                            </div>
                          </div>
                          <div className="kick__ticker__cell-text">
                            <div className="kick__ticker__cell-text-inner">
                              {event.type != SportsTickerEventType.Ad &&
                                <>
                                  {event.headline && (
                                      <strong>{event.headline}<br /></strong>
                                  )}
                                  {event.text && (
                                      <span>{event.text}</span>
                                  )}
                                  {event.subline && (
                                      <span>{event.subline}</span>
                                  )}
                                  {event.minute == 0 && (
                                    <div className="kick__ticker-hr"></div>
                                  )}
                                </>
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="kick__data-grid__side">
                {sportsticker?.lineup && (
                  <div id="aufstellung">
                    <TickerLineup sportsTicker={sportsticker} />
                  </div>
                )}
                {sportsmatches?.matches && (
                  <div id="spieltag">
                    <TickerEncounter sportsMatches={sportsmatches} />
                  </div>
                )}
                {sportstables && sportstables.length > 0 && (
                  sportstables.map((sportsTable, index) => (
                    <div id={`tabelle-${index}`} key={`tabelle-${index}`}>
                      <TickerTable sportsTable={sportsTable} />
                    </div>
                  ))
                )}
            </div>
          </div>
        </header>
      </div>
    </React.Fragment>
  );
}
